import { Decimal } from 'decimal.js';
import { poolDetailsMap } from '../common/maps.js';
import { coinsListByType } from '../common/coinsList.js';
export class Portfolio {
    protocol;
    blockchain;
    suiClient;
    userAddress;
    constructor(protocol, blockchain, suiClient, userAddress) {
        this.protocol = protocol;
        this.blockchain = blockchain;
        this.suiClient = suiClient;
        this.userAddress = userAddress;
    }
    async getAllReceipts(pools) {
        const receiptTypes = Array.from(pools.values()).map((pool) => pool.poolDetails.receipt.type);
        const receipts = await this.blockchain.multiGetReceipts(this.userAddress, receiptTypes);
        return receipts;
    }
    async getWalletCoins() {
        const res = await this.suiClient.getAllBalances({
            owner: this.userAddress,
        });
        const resMap = new Map();
        res.forEach((entry) => {
            resMap.set(entry.coinType, entry.totalBalance);
        });
        return resMap;
    }
    async fetchUserLockedBalances(lockedTableID) {
        let currentCursor = null;
        const data = [];
        do {
            const response = await this.suiClient.getDynamicFields({
                parentId: lockedTableID,
                cursor: currentCursor,
            });
            data.push(...response.data);
            if (response.hasNextPage) {
                currentCursor = response.nextCursor;
            }
            else {
                break;
            }
        } while (true);
        const res = await this.suiClient.multiGetObjects({
            ids: data.map((item) => item.objectId),
            options: {
                showContent: true,
            },
        });
        return res.map((item) => {
            const fields = (item.data?.content).fields;
            return {
                timestamp: fields.name,
                xTokenBalance: fields.value.fields.value,
            };
        });
    }
    async getFungileDeposits(pools, walletCoins, priceMap, naviLoopingPoolDebt) {
        const result = new Map();
        for (const poolDetails of Object.values(poolDetailsMap)) {
            if (poolDetails.strategyType === 'FUNGIBLE-DOUBLE-ASSET-POOL') {
                const totalXTokens = new Decimal(walletCoins.get(poolDetails.fungibleCoinType || '') || '0');
                const pool = pools.get(poolDetails.poolId);
                if (totalXTokens.gt(0) && pool) {
                    const poolExchangeRate = pool.poolExchangeRate(priceMap, naviLoopingPoolDebt);
                    const liquidity = totalXTokens.mul(poolExchangeRate);
                    const res = pool.coinAmountsFromLiquidity(liquidity.toString());
                    const amounts = [
                        res[0].div(Math.pow(10, coinsListByType[poolDetails.assetTypes[0]].expo)),
                        res[1].div(Math.pow(10, coinsListByType[poolDetails.assetTypes[1]].expo)),
                    ];
                    result.set(poolDetails.poolId, amounts);
                }
            }
        }
        return result;
    }
}
//# sourceMappingURL=portfolio.js.map